import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const forgePersonalSettingsRoute: InvariantJiraRoute = {
	name: 'forge-spa-personal-settings',
	path: '/jira/settings/personal/apps/:appId/:envId/:route?',
};
